/**
 * Probabilistic sampling gate (PUN-5039).
 *
 * Returns `true` on a `rate` fraction of calls, so a prompt can be shown to
 * only a slice of qualifying actions without fatiguing users. `rate` is a
 * probability in [0, 1]; values <= 0 (and NaN) never sample, values >= 1 always
 * sample. `rng` is injectable so tests are deterministic; it defaults to
 * `Math.random`.
 */
export function shouldSample(
  rate: number,
  rng: () => number = Math.random
): boolean {
  if (!(rate > 0)) return false;
  if (rate >= 1) return true;
  return rng() < rate;
}
